export default [
  { value: "ALL", label: "ALL" },
  { value: "ADMIN", label: "ADMIN" },
  { value: "STATS", label: "STATS" },
  { value: "STRONG", label: "STRONG" },
  { value: "ADV", label: "ADV" },
  { value: "SAV", label: "SAV" },
  { value: "TLV", label: "TLV" },
  { value: "SAVREP", label: "SAVREP" },
  { value: "QUALITE", label: "QUALITE" },
  { value: "WEB", label: "WEB" },
  { value: "COMTPA", label: "COMTPA" },
  { value: "MARKETING", label: "MARKETING" },
];
